exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-icon[data-v-e0f2261c]{margin-left:16px;height:32px}.balance-background[data-v-e0f2261c]{display:block;margin-top:-24px;margin-left:auto;margin-bottom:-8px;max-width:190px;width:60%}.empty-transaction-icon[data-v-e0f2261c]{display:inline-block;margin-top:8px;margin-bottom:8px;margin-left:16px;height:60px}.empty-harvest-icon[data-v-e0f2261c]{display:inline-block;margin-top:-8px;margin-left:16px;height:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e0f2261c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pages/top/Home.vue
// module id = 824
// module chunks = 1